import React from 'react';
import CustomAlert from "./CustomAlert";

const IsError:React.FC<{isError:boolean,width?:string}> = ({isError, width="100%"}) => {
    return (
        <>
            {isError&&<CustomAlert message={"Произошла ошибка, попробуйте обновить страницу"} status={"error"} width={width}/>}
        </>
    );
};

export default IsError;